import {Component, OnInit} from "@angular/core";
import {takeUntil, tap} from "rxjs/operators";
import {OfferJourneyService} from "../../../offer-flow/services/offer-journey/offer-journey.service";
import {JourneySettingsService} from "../../../offer-flow/services/journey-settings.service";
import {DestroyableBase} from "fello-common";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent extends DestroyableBase implements OnInit {
  constructor(private offerJourneyService: OfferJourneyService, private journeySettingsService: JourneySettingsService) {
    super();
  }
  progressPerc: number;
  journeySettings$ = this.journeySettingsService.settings$;

  ngOnInit(): void {
    this.offerJourneyService.felloOfferJourney
      .pipe(
        takeUntil(this.isDestroyed),
        tap(journey => {
          this.progressPerc = journey.progressPerc;
        })
      )
      .subscribe();
  }
}
